import { HomeFilters, WorkspaceState, WorkspaceTab } from './workspace.type'

export const WorkspaceActionTypes: { [key: string]: string } = {
  hydrateState: 'WORKSPACE_hydrateState',
  openTab: 'WORKSPACE_openTab',
  closeTab: 'WORKSPACE_closeTab',
  closeAllTabs: 'WORKSPACE_closeAllTabs',
  updateTab: 'WORKSPACE_updateTab',
  updateFilters: 'WORKSPACE_updateFilters',
}

export const WorkspaceAction = {
  hydrateState: (state: WorkspaceState): { state: WorkspaceState; type: string } => {
    return {
      type: WorkspaceActionTypes.hydrateState,
      state,
    }
  },
  openTab: (tab: WorkspaceTab): { tab: WorkspaceTab; type: string } => {
    return {
      type: WorkspaceActionTypes.openTab,
      tab,
    }
  },
  closeTab: (tab: WorkspaceTab): { tab: WorkspaceTab; type: string } => {
    return {
      type: WorkspaceActionTypes.closeTab,
      tab,
    }
  },
  closeAllTabs: (): { type: string } => {
    return {
      type: WorkspaceActionTypes.closeAllTabs,
    }
  },
  updateTab: (tab: WorkspaceTab): { tab: WorkspaceTab; type: string } => {
    return {
      type: WorkspaceActionTypes.updateTab,
      tab,
    }
  },
  updateFilters: (filters: Partial<HomeFilters>): { filters: Partial<HomeFilters>; type: string } => {
    return {
      type: WorkspaceActionTypes.updateFilters,
      filters,
    }
  },
}
